/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RetarificationFraisValeurDto } from './RetarificationFraisValeurDto';
import {
    RetarificationFraisValeurDtoFromJSON,
    RetarificationFraisValeurDtoFromJSONTyped,
    RetarificationFraisValeurDtoToJSON,
    RetarificationFraisValeurDtoToJSONTyped,
} from './RetarificationFraisValeurDto';
import type { RetarificationGarantieSelectionDto } from './RetarificationGarantieSelectionDto';
import {
    RetarificationGarantieSelectionDtoFromJSON,
    RetarificationGarantieSelectionDtoFromJSONTyped,
    RetarificationGarantieSelectionDtoToJSON,
    RetarificationGarantieSelectionDtoToJSONTyped,
} from './RetarificationGarantieSelectionDto';
import type { RetarificationVariableValeurDto } from './RetarificationVariableValeurDto';
import {
    RetarificationVariableValeurDtoFromJSON,
    RetarificationVariableValeurDtoFromJSONTyped,
    RetarificationVariableValeurDtoToJSON,
    RetarificationVariableValeurDtoToJSONTyped,
} from './RetarificationVariableValeurDto';

/**
 * The validator changes the quote (at least one change) and accepts it: same re-pricing state as the simulation, plus an optional message and special clause.
 * 
 * @export
 * @interface ValiderAvecModificationsCommand
 */
export interface ValiderAvecModificationsCommand {
    /**
     * 
     * @type {Array<RetarificationGarantieSelectionDto>}
     * @memberof ValiderAvecModificationsCommand
     */
    garanties: Array<RetarificationGarantieSelectionDto>;
    /**
     * 
     * @type {Array<RetarificationVariableValeurDto>}
     * @memberof ValiderAvecModificationsCommand
     */
    variables: Array<RetarificationVariableValeurDto>;
    /**
     * 
     * @type {Array<RetarificationFraisValeurDto>}
     * @memberof ValiderAvecModificationsCommand
     */
    frais: Array<RetarificationFraisValeurDto>;
    /**
     * Optional message to the broker.
     * @type {string}
     * @memberof ValiderAvecModificationsCommand
     */
    message?: string | null;
    /**
     * Optional special clause (free text) added to the quote.
     * @type {string}
     * @memberof ValiderAvecModificationsCommand
     */
    clauseParticuliere?: string | null;
}

/**
 * Check if a given object implements the ValiderAvecModificationsCommand interface.
 */
export function instanceOfValiderAvecModificationsCommand(value: object): value is ValiderAvecModificationsCommand {
    if (!('garanties' in value) || value['garanties'] === undefined) return false;
    if (!('variables' in value) || value['variables'] === undefined) return false;
    if (!('frais' in value) || value['frais'] === undefined) return false;
    return true;
}

export function ValiderAvecModificationsCommandFromJSON(json: any): ValiderAvecModificationsCommand {
    return ValiderAvecModificationsCommandFromJSONTyped(json, false);
}

export function ValiderAvecModificationsCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValiderAvecModificationsCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'garanties': ((json['garanties'] as Array<any>).map(RetarificationGarantieSelectionDtoFromJSON)),
        'variables': ((json['variables'] as Array<any>).map(RetarificationVariableValeurDtoFromJSON)),
        'frais': ((json['frais'] as Array<any>).map(RetarificationFraisValeurDtoFromJSON)),
        'message': json['message'] == null ? undefined : json['message'],
        'clauseParticuliere': json['clauseParticuliere'] == null ? undefined : json['clauseParticuliere'],
    };
}

export function ValiderAvecModificationsCommandToJSON(json: any): ValiderAvecModificationsCommand {
    return ValiderAvecModificationsCommandToJSONTyped(json, false);
}

export function ValiderAvecModificationsCommandToJSONTyped(value?: ValiderAvecModificationsCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'garanties': ((value['garanties'] as Array<any>).map(RetarificationGarantieSelectionDtoToJSON)),
        'variables': ((value['variables'] as Array<any>).map(RetarificationVariableValeurDtoToJSON)),
        'frais': ((value['frais'] as Array<any>).map(RetarificationFraisValeurDtoToJSON)),
        'message': value['message'],
        'clauseParticuliere': value['clauseParticuliere'],
    };
}

